import React from 'react';
import PropTypes from 'prop-types';

import './text-input.scss';
import { getClass } from '../../../../utils/component-helpers';

const NumberInput = props => {
  const { value, name, subLabel, placeholder, onChange, errors, disabled } = props;

  return (
    <div className="input">
      <input
        type="text"
        name={name}
        value={value}
        placeholder={placeholder}
        min={0}
        onChange={e => {
          const numberRegex = /^\d{0,10}(?:\.\d{0,2})?$/;
          if (e.target.value.match(numberRegex)) {
            onChange(e);
          }
        }}
        className={getClass({ invalid: errors.length })}
        disabled={disabled}
      />
      <div className="sub-label">{subLabel}</div>
      <div className="error-messages">
        {errors.map(message => (
          <div key={message}>{message}</div>
        ))}
      </div>
    </div>
  );
};

NumberInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  subLabel: PropTypes.string,
  labelType: PropTypes.oneOf(['horizontal', 'vertical']),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  errors: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
};

NumberInput.defaultProps = {
  value: '',
  label: '',
  labelType: 'vertical',
  subLabel: '',
  placeholder: '',
  required: false,
  onChange: () => {},
  errors: [],
  disabled: false,
};

export default NumberInput;
